<script setup lang="ts">
import { cn } from "@/lib/utils";

interface DialogIconProps {
    class?: string;
}

const props = defineProps<DialogIconProps>();
</script>

<template>
    <div
        :class="
            cn(
                'h-12 w-12 rounded-lg border-iron-100 bg-white shadow-md flex shrink-0 items-center justify-center border',
                props.class,
            )
        "
    >
        <slot />
    </div>
</template>
